import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HotelCard from '../../../../screens/customer/PublicCustomerScreens/HotelCard';
import '../../../../assets/css/customer/hotelspages/hotellist.css';

const HotelList = ({ hotels, onViewDetails, wishlistIds, onWishlist }) => {
  if (hotels.length === 0) {
    return (
      <div className="cus-htl-no-results">
        <h3>No hotels found</h3>
        <p>We couldn't find any hotels matching your search criteria.</p>
        <p>Try searching for a different city or adjusting your filters.</p>
      </div>
    );
  }

  return (
    <Container fluid className="cus-htl-list-container">
      <Row>
        {hotels.map((hotel) => (
          <Col key={hotel.id} lg={4} md={6} sm={12} className="mb-4">
            <HotelCard
              hotel={hotel}
              onViewDetails={onViewDetails}
              isWishlisted={wishlistIds?.includes(Number(hotel.id))}
              onWishlist={onWishlist}
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default HotelList;